import React, { useEffect, useRef } from 'react';
import PDFObject from 'pdfobject';
import { v4 } from 'uuid';
import { FilePdfEmbedContainer } from './File.styled';

// Detect desktop versions of Safari. Safari requires an iframe to properly support
// embeds with redirects, and will crash the tab if you attempt to use an embed or
// object tag directly. Firefox, if its settings are modified to ask for permission
// to download files, will prompt the user to download files embedded in an iframe.
//
// To get around this issue, we have to manually switch the behaviour depending
// on the user agent.
const isDesktopSafari = /((?!chrome|android).)*safari/i.test(
  navigator.userAgent,
);

type PDFObjectContainerProps = {
  url: string;
};

export const PDFObjectContainer = (props: PDFObjectContainerProps) => {
  const { url } = props;
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      PDFObject.embed(url, containerRef.current, {
        id: v4(),
        assumptionMode: true,
        supportRedirect: isDesktopSafari, // Required for Safari on macOS
        forceIframe: false,
        width: '100%',
        height: '440px',
      });
    }
  }, [url, containerRef]);

  return <FilePdfEmbedContainer ref={containerRef} />;
};
